import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star, Video, FileText, Phone } from 'lucide-react';
import type { CommitmentTaskType } from '@clareefai/types';

interface CommitmentTaskBadgeProps {
  type: CommitmentTaskType;
  requiredCount?: number;
}

const BADGE_STYLE: Record<CommitmentTaskType, { icon: React.ComponentType<any>; color: string; bg: string }> = {
  REVIEW: { icon: Star, color: 'text-blue-700', bg: 'bg-blue-100' },
  VIDEO: { icon: Video, color: 'text-purple-700', bg: 'bg-purple-100' },
  USE_CASE: { icon: FileText, color: 'text-orange-700', bg: 'bg-orange-100' },
  REFERENCE_CALL: { icon: Phone, color: 'text-green-700', bg: 'bg-green-100' },
};

const CommitmentTaskBadge: React.FC<CommitmentTaskBadgeProps> = ({ type, requiredCount }) => {
  const { t } = useTranslation();
  const style = BADGE_STYLE[type];
  const Icon = style.icon;

  const TASK_LABELS: Record<CommitmentTaskType, string> = {
    REVIEW: t('rewards.specific.tasks.review'),
    VIDEO: t('rewards.specific.tasks.video'),
    USE_CASE: t('rewards.specific.tasks.useCase'),
    REFERENCE_CALL: t('rewards.specific.tasks.referenceCall'),
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${style.bg} ${style.color}`}>
      <Icon className="w-3 h-3" />
      {TASK_LABELS[type]}
      {requiredCount && requiredCount > 1 ? ` x${requiredCount}` : ''}
    </span>
  );
};

export default CommitmentTaskBadge;
